import React from 'react';

import CheckUniqueUsername from '@src/api/CheckUniqueUsername';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';

const useCheckUniqueUsername = () => {
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(
    async (username: string): Promise<boolean> => {
      const response = await CheckUniqueUsername(username, axiosRequestConfig);
      return response.data.status === 200 ? true : false;
    },
    [axiosRequestConfig]
  );

  return makeRequest;
};

export default useCheckUniqueUsername;
